import { createWebHistory, createRouter } from "vue-router";
import UploadView from "@/views/UploadView.vue";
import HomeView from "@/views/HomeView.vue";
import TableView from "@/views/TableView.vue";
import TrendView from "@/views/TrendView.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/upload",
    name: "Upload",
    component: UploadView,
  },
  {
    path: "/table",
    name: "Table",
    component: TableView,
  },
  {
    path: "/trend",
    name: "Trend",
    component: TrendView,
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
